export const capitalize = (str?: string) => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const formatToTitleCase = (columnName: string) => {
  const wordsToRemove = ['id', 'is']
  return columnName
    .replace(/_/g, ' ')
    .split(' ')
    .filter((word) => !wordsToRemove.includes(word.toLowerCase())) // Remove unwanted words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
